export const stockStatusTranslations = {
  instock: 'Na zalihama',
  outofstock: 'Rasprodato',
  onbackorder: 'Na čekanju',
};

// Hover-tooltip explanations for the product flag switches (Brza podešavanja modal + ProductForm).
// Keep in sync with the API's pricing rules (order-pricing.service.ts, pricing.util.ts).
export const PRODUCT_FLAG_TOOLTIPS = {
  isProductHidden:
    'Proizvod može da se doda u pretplatu. Kada je isključeno, proizvod nestaje iz izbora za pretplatu i uklanja se iz postojećih pretplata (pretplata koja ostane prazna se deaktivira). Ne sakriva proizvod iz prodavnice – za to služi „Sakrij proizvod“.',
  isConfigurationProduct:
    'Mix4 paket: u korpi mora biti ukupno najmanje 4 komada konfiguracionih proizvoda (bilo koja kombinacija). Popust na paket je 15% (VIP 25%) od redovne cene. Ne dobija VIP cenu niti količinski popust po proizvodu.',
  isMix4IndividuallySellable:
    'Dozvoljava da se ovaj Mix4 proizvod kupi i pojedinačno, van Mix4 paketa (bez pravila od najmanje 4 komada i bez Mix4 popusta) — u redovnoj prodavnici i u pretplati. Ako je isključeno, proizvod se može kupiti samo kao deo Mix4 paketa.',
  hasQuantityDiscount:
    'Popust na osnovu količine ovog proizvoda: 2–3 kom. 10% (VIP 20%), 4+ kom. 15% (VIP 25%), od redovne cene – umesto VIP cene. Svaki količinski popust poništava 5% mentorski popust za celu porudžbinu. Ne važi za konfiguracione proizvode.',
  isEligibleToBuyWithPoints:
    'Proizvod može da se plati poenima. Kada je isključeno, porudžbina poenima koja sadrži ovaj proizvod se odbija.',
  isExternalProduct:
    'Proizvod spoljnog dobavljača: ne dobija VIP cenu. Ako je u korpi, cela porudžbina gubi 5% mentorski popust i ne donosi cashback poene.',
  isSubscriptionOnlyProduct:
    'Paket koji se prodaje isključivo kao pretplatnički paket (3/6/12 meseci). Ne može da se kupi u običnoj jednokratnoj porudžbini. Neophodno da bi se za proizvod podesio pretplatnički paket.',
  isFrozenProduct:
    'Zamrznut proizvod: porudžbina koja ga sadrži uvek plaća dostavu od 990 RSD, i za VIP članove, bez obzira na iznos porudžbine.',
  skipReferredDiscount:
    'Samo ovaj proizvod se izuzima iz 5% mentorskog popusta. Ostali proizvodi u korpi i dalje dobijaju popust.',
  checkoutUpsell:
    'Proizvod se nudi na checkout-u uz dodatni popust (%). Taj popust zamenjuje VIP i količinski popust za ovu stavku, a 5% mentorski popust se na nju ne primenjuje. Samo jedan proizvod može biti aktivna ponuda.',
  mentorCommissionChain:
    'Posebni procenti provizije mentorskog lanca za ovaj proizvod (zbir nivoa ≤ maksimalan %). Ako bilo koji proizvod u porudžbini ima ovo podešavanje, provizija se za celu porudžbinu računa po stavkama.',
  agentCommission:
    'Poseban procenat provizije za agenta na ovom proizvodu, umesto opšteg procenta iz podešavanja. Agent nema nivoe kao mentor — samo jedan procenat po proizvodu.',
};

// Grouped layout of the product flag switches in ProductForm (add/edit product).
// `inverted`: the switch shows the opposite of the stored field (isProductHidden).
export const PRODUCT_FLAG_GROUPS = [
  {
    title: 'Cene i popusti',
    flags: [
      { key: 'hasQuantityDiscount', label: 'Količinski popust', summary: '2–3 kom. 10%, 4+ kom. 15% (VIP 20% / 25%)' },
      { key: 'isConfigurationProduct', label: 'Konfiguracioni proizvod', summary: 'Mix4 paket — najmanje 4 komada u korpi' },
      { key: 'isMix4IndividuallySellable', label: 'Mix4 — pojedinačna prodaja', summary: 'Dozvoljava kupovinu van Mix4 paketa, bez pravila od 4 komada' },
      { key: 'skipReferredDiscount', label: 'Isključi 5% popust', summary: 'Ovaj proizvod ne dobija 5% mentorski popust' },
      { key: 'isExternalProduct', label: 'Eksterni proizvod', summary: 'Bez VIP cene; cela porudžbina gubi 5% i cashback' },
    ],
  },
  {
    title: 'Pretplata',
    flags: [
      { key: 'isProductHidden', inverted: true, label: 'Pretplatnički proizvod', summary: 'Može da se doda u pretplatu' },
      { key: 'isSubscriptionOnlyProduct', label: 'Pretplatnički paket (3/6/12)', summary: 'Prodaje se samo kao paket, ne jednokratno' },
    ],
  },
  {
    title: 'Plaćanje i dostava',
    flags: [
      { key: 'isEligibleToBuyWithPoints', label: 'Kupovina poenima', summary: 'Može da se plati loyalty poenima' },
      { key: 'isFrozenProduct', label: 'Zamrznut proizvod', summary: 'Dostava uvek 990 RSD, i za VIP' },
    ],
  },
];
